/**
 * M365 accounts permitted to act on BQC5's Sup Approval tab — the review
 * layer over an in-house repair (a defect QC judged minor enough to fix on
 * the floor instead of returning to the subcontractor, usually to make a
 * near due date). Distinct from qc@/qc1@/etc, who record the outcome itself;
 * this list is who signs off on the call to keep it in-house.
 */
export const SUP_APPROVAL_ALLOWED_USERS: string[] = [
  "operations@intalgarmentsopc.onmicrosoft.com",
];
